import { Fragment, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./video-ai.css";
import axios from "axios";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import PageHeading from "../../Components/PageHeading/PageHeading";
import swal from "sweetalert";
import CreditsButton from "../../utils/CreditsButton";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from "@material-ui/core";
import SampleVideoModal from "../../Components/VideoAi/SampleVideoModal";
import SampleTextVideo from "../../Components/AIVideoSample/TextVideo";

const VideoAiNews = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [randomQuestion, setRandomQuestion] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [attributionPage, setAttributionPage] = useState(true);
  const [query, setQuery] = useState("");
  const [event, setEvent] = useState("All"); // Default value previously was "Day"
  const [newsData, setNewsData] = useState({});
  const [newsCategory, setNewsCategory] = useState("Business");
  const [videoModal, setVideoModal] = useState(false);
  const [oneNews, setOneNews] = useState();
  const [videoPosition, setVideoPosition] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [isBwGradient, setIsBwGradient] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [isRandomGradient, setIsRandomGradient] = useState(false);
  const [isRandomColor, setIsRandomColor] = useState(false);
  const [isWhite, setIsWhite] = useState(false);

  const [randomNews, setRandomNews] = useState();

  const resetBackgroundStates = () => {
    setIsBwGradient(false);
    setIsDark(false);
    setIsRandomGradient(false);
    setIsRandomColor(false);
    setIsWhite(false);
  };

  const handleOptionChange = (e) => {
    const value = e.target.value;

    setSelectedOption(value);
    resetBackgroundStates();

    switch (value) {
      case "Black to White Gradient":
        setIsBwGradient(true);
        setVideoPosition(5);
        break;

      case "Random Solid Color":
        setIsRandomColor(true);
        setVideoPosition(6);
        break;

      case "Random Color Gradient":
        setIsRandomGradient(true);
        setVideoPosition(7);
        break;

      case "Black":
        setIsDark(true);
        setVideoPosition(8);
        break;

      case "White":
        setIsWhite(true);
        setVideoPosition(9);
        break;

      default:
        setVideoPosition(0);
        break;
    }
  };

  // Function to get a random question
  const getRandomQuestion = () => {
    const questions = [
      "The Basics of Quantum Physics Explained",
      "Understanding the Human Digestive System",
      "How the Internet Works: A Simple Guide",
      "Introduction to Machine Learning",
      "The History of Ancient Rome",
      "The Science Behind Climate Change",
      "Introduction to the Solar System",
      "How to Write an Effective Essay",
      "Understanding the Stock Market",
      "The Fundamentals of Algebra",
      "The Water Cycle Explained",
      "A Beginner’s Guide to Coding",
      "The French Revolution: A Brief Overview",
      "How Photosynthesis Works",
      "Introduction to World Religions",
      "The Life Cycle of a Star",
      "Understanding Artificial Intelligence",
      "How Does DNA Work?",
      "Introduction to Financial Literacy",
      "The History of the Internet",
      "How the Immune System Protects You",
      "The Basics of Electricity",
      "Exploring the Human Brain",
      "What is Cryptocurrency?",
      "Understanding Probability and Statistics",
      "How to Learn a New Language Fast",
      "The Structure of the Earth",
      "What is the Theory of Evolution?",
      "Introduction to Cybersecurity",
      "How Planes Fly: The Physics of Aviation",
      "The Causes of World War I",
      "Understanding Chemical Reactions",
      "How to Create a Budget That Works",
      "The Basics of Astronomy",
      "Introduction to Political Science",
      "How Do Vaccines Work?",
      "Understanding Renewable Energy",
      "The Anatomy of the Human Heart",
      "The History of Mathematics",
      "Introduction to Blockchain Technology",
      "The Life of Plants: An Overview",
      "How to Improve Your Memory",
      "Understanding the Laws of Motion",
      "The Basics of Digital Marketing",
      "Introduction to Public Speaking",
      "How to Study Effectively",
      "Understanding Ocean Currents",
      "The History of Ancient Egypt",
      "Introduction to Psychology",
      "The Basics of Graphic Design",
      "How to Build Good Habits",
      "Understanding Global Warming",
      "The Fundamentals of Trigonometry",
      "The Science of Happiness",
      "Introduction to Data Science",
      "How to Develop Critical Thinking Skills",
      "Understanding the Human Skeletal System",
      "The History of the Renaissance",
      "Introduction to Organic Chemistry",
      "The Basics of Video Editing",
      "How the Nervous System Works",
      "Understanding the Fundamentals of Music Theory",
      "The History of the Industrial Revolution",
      "Introduction to Environmental Science",
      "How to Conduct Effective Research",
      "Understanding the Periodic Table",
      "The Basics of 3D Printing",
      "Introduction to Ethical Hacking",
      "How to Write a Research Paper",
      "Understanding the Human Respiratory System",
      "The History of World War II",
      "Introduction to Sociology",
      "The Basics of Sound Waves",
      "How to Improve Your Public Speaking Skills",
      "Understanding Genetic Engineering",
      "The Fundamentals of Calculus",
      "The Science of Sleep",
      "Introduction to Space Exploration",
      "How to Prepare for Exams Effectively",
      "Understanding Light and Optics",
      "The History of the Cold War",
      "Introduction to Microbiology",
      "How to Create a Business Plan",
      "Understanding Earthquakes",
      "The Basics of Project Management",
      "Introduction to Machine Learning Algorithms",
      "How to Set and Achieve Goals",
      "Understanding Ecosystems",
      "The History of the American Civil War",
      "Introduction to Robotics",
      "The Basics of Human Anatomy",
      "How to Build a Website from Scratch",
      "Understanding the Solar System",
      "The Science Behind Vaccines",
      "Introduction to Web Development",
      "How to Excel in Math",
      "Understanding Nutrition and Diet",
      "The History of Computers",
      "Introduction to International Relations",
      "The Basics of Electrical Circuits",
      "How to Develop Time Management Skills",
      "Understanding Black Holes",
      "The History of Ancient Greece",
      "Introduction to Statistics",
      "How to Improve Your Writing Skills",
      "Understanding the Water Cycle",
      "The Fundamentals of Economics",
      "The Science of Climate Change",
      "Introduction to Virtual Reality",
      "How to Be More Productive",
      "Understanding the Immune Response",
      "The History of the Space Race",
      "Introduction to Biology",
      "The Basics of Investing",
      "How to Develop Problem-Solving Skills",
      "Understanding Human Evolution",
      "The History of Art Movements",
      "Introduction to Artificial Neural Networks",
      "The Science of Exercise and Fitness",
      "How to Create Effective Presentations",
      "Understanding Cellular Respiration",
      "The History of the French Revolution",
      "Introduction to Genetic Engineering",
      "The Basics of Human Geography",
      "How to Plan a Career Path",
      "Understanding the Laws of Thermodynamics",
      "The History of Ancient China",
      "Introduction to Entrepreneurship",
      "The Science of Sound",
      "How to Stay Focused While Studying",
      "Understanding Marine Biology",
      "The Basics of Marketing Strategies",
      "Introduction to Philosophy",
      "How to Develop Leadership Skills",
      "Understanding Human Rights",
      "The History of the Roman Empire",
      "Introduction to Social Media Marketing",
      "The Science of Light",
      "How to Overcome Procrastination",
      "Understanding the Earth's Atmosphere",
      "The History of the Scientific Revolution",
      "Introduction to Nanotechnology",
      "The Basics of Creative Writing",
      "How to Communicate Effectively",
      "Understanding Ecosystem Dynamics",
      "The History of Ancient India",
      "Introduction to Game Design",
      "The Science of Nutrition",
      "How to Develop Emotional Intelligence",
      "Understanding the Structure of Atoms",
      "The History of Space Exploration",
      "Introduction to Web Security",
      "The Basics of Financial Planning",
      "How to Learn Faster",
      "Understanding Quantum Mechanics",
      "The History of the Middle Ages",
      "Introduction to Astrobiology",
      "The Science of Motivation",
      "How to Build a Personal Brand",
      "Understanding the Greenhouse Effect",
      "The History of the Atomic Bomb",
      "Introduction to Cryptography",
      "The Basics of User Experience Design",
      "How to Think Critically",
      "Understanding Social Psychology",
      "The History of the Byzantine Empire",
      "Introduction to Geology",
      "The Science of Stress Management",
      "How to Build a Mobile App",
      "Understanding the Structure of DNA",
      "The History of the Silk Road",
      "Introduction to Behavioral Economics",
      "The Basics of Cloud Computing",
      "How to Overcome Test Anxiety",
      "Understanding Plate Tectonics",
      "The History of Medieval Europe",
      "Introduction to Renewable Energy Technologies",
      "The Science of Cognitive Biases",
      "How to Develop a Growth Mindset",
      "Understanding the Human Circulatory System",
      "The History of the Renaissance Art",
      "Introduction to Artificial Intelligence Ethics",
      "The Basics of Computer Networks",
      "How to Improve Your Logical Reasoning Skills",
      "Understanding the Physics of Gravity",
      "The History of Modern Medicine",
      "Introduction to Environmental Sustainability",
      "The Science of Human Behavior",
      "How to Build Confidence",
      "Understanding the Process of Evolution",
      "The History of Space Technology",
      "Introduction to Astrophysics",
      "The Basics of Data Analysis",
      "How to Cultivate Creativity",
      "Understanding Chemical Bonding",
      "The History of the Industrial Age",
      "Introduction to Digital Art",
      "The Science of Learning",
      "How to Create a Successful YouTube Channel",
      "Understanding the Anatomy of Plants",
    ];

    const randomIndex = Math.floor(Math.random() * questions.length);
    return questions[randomIndex];
  };

  function parseDate(dateStr) {
    // dateStr format: "08-12-2025 11:53:03"
    const [date, time] = dateStr.split(" ");
    const [day, month, year] = date.split("-");
    return new Date(`${year}-${month}-${day}T${time}`);
  }

  const fetchNewsByCategory = async (newsCategory, event) => {
    const type = event?.toLowerCase();

    try {
      const response = await fetch(
        `https://backend.whalesai.com/api/v1/admin/news/get/news/${newsCategory}?event=${type}`
      );
      const data = await response.json();

      const sortedData = data
        ? [...data].sort((a, b) => {
          const dateA = parseDate(a.updatedAt);
          const dateB = parseDate(b.updatedAt);
          return dateB - dateA; // newest first
        })
        : [];

      setRandomNews(sortedData);
    } catch (error) {
      console.error("Error fetching news by category:", error);
    }
  };

  useEffect(() => {
    fetchNewsByCategory(newsCategory, event);
  }, [newsCategory, event]);


  // Set random question when component mounts
  useEffect(() => {
    setRandomQuestion(getRandomQuestion());
  }, []);

  const { AIuser, userRefetch, setUserRefetch, isBack } =
    useContext(UserAuthContext);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location, isBack]);

  function generateRandomAlphanumeric() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  }

  const handleSubmitCredits = async (e) => {
    const deductedCredits = AIuser.credits - 35;

    // console.log("question", question, conversation);
    await axios
      .put(
        "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
        { email: AIuser?.email, credits: deductedCredits },
        {
          headers: {
            authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setUserRefetch(!userRefetch);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const generateNews = async () => {
    fetchNewsByCategory(newsCategory);
    setOneNews("");
    setIsLoading(true);
    const response = await axios.get(
      `https://backend.whalesai.com/api/v1/news/get`,
      {
        params: { category: newsCategory, event },
      }
    );
    const data = await response.data.articles;
    if (response.data.statusCode === 404) {
      return swal({
        icon: "warning",
        title: "Something Went Wrong!",
        button: "Close",
        className: "modal_class_success",
      });
    }
    // Randomize the data order
    const shuffledData = data ? [...data].sort(() => Math.random() - 0.5) : [];
    setNewsData(shuffledData);
    setIsLoading(false);
    setQuery("");
  };

  const handleCheckedNews = (item) => {
    setOneNews(item);
  };

  const handleChecked = async () => {
    if (AIuser.credits > 35) {
      setTimeout(() => {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = `<p></p> <p class="text-white">we are generating the video for you. We will send the video links to <span class="text-warning">${AIuser?.email}</span>. It might take up to 10 mins. <br/> You can generate more contents while waiting for our email.</p> `;

        swal({
          content: wrapper,
          icon: "success",
          button: "Close",
          className: "modal_class_success",
        }).then(() => {
          // Update the button text to "Refreshing the page for you"
          swal({
            icon: "success",
            button: {
              text: "Refreshing the page for you",
              className: "bg-danger",
            },
            className: "modal_class_success",
            closeOnClickOutside: false, // Prevent closing by clicking outside
          });

          // Reload the page after a short delay to allow the user to see the updated text
          setTimeout(() => {
            window.location.reload();
          }, 1000); // Adjust the delay as needed
        });
      }, 1000);

      setIsLoading(true);
      handleSubmitCredits();

      const bodyContent = {
        email: AIuser?.email,
        userId: AIuser?._id,
        isDark,
        isBwGradient,
        isRandomColor,
        isRandomGradient,
        isWhite,
        transactionId: generateRandomAlphanumeric(),
        description: oneNews?.summary,
        question: oneNews?.title,
        url: "",
        attributionPage,
        credit: 35,
      };

      try {
        const response = await fetch(
          `https://backend.whalesai.com/api/v1/img/generate-news-video?dimension=all`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(bodyContent),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to generate video");
        }

        const data = await response.json();
        if (data.message === "Video created successfully") {
          alert("video created successfully");

          setIsLoading(false);
        } else {
          throw new Error("Failed to generate video");
        }
      } catch (error) {
        console.error("Error generating video:", error);
      }
    } else {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",

        icon: "error",
        buttons: "Buy",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/purchase");
        }
      });
    }
  };

  const handleCheckedComic = async () => {
    if (AIuser.credits > 120) {
      setTimeout(() => {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = `<p></p> <p class="text-white">we are generating the video for you. We will send the video links to <span class="text-warning">${AIuser?.email}</span>. It might take up to 10 mins. <br/> You can generate more contents while waiting for our email.</p> `;

        swal({
          content: wrapper,
          icon: "success",
          button: "Close",
          className: "modal_class_success",
        }).then(() => {
          // Update the button text to "Refreshing the page for you"
          swal({
            icon: "success",
            button: {
              text: "Refreshing the page for you",
              className: "bg-danger",
            },
            className: "modal_class_success",
            closeOnClickOutside: false, // Prevent closing by clicking outside
          });

          // Reload the page after a short delay to allow the user to see the updated text
          setTimeout(() => {
            window.location.reload();
          }, 1000); // Adjust the delay as needed
        });
      }, 1000);

      setIsLoading(true);
      handleSubmitCredits();

      const bodyContent = {
        email: AIuser?.email,
        userId: AIuser?._id,
        isDark,
        isBwGradient,
        isRandomColor,
        isRandomGradient,
        isWhite,
        transactionId: generateRandomAlphanumeric(),
        description: oneNews?.comicSummary,
        question: oneNews?.title,
        attributionPage,
        credit: 35,
      };

      try {
        const response = await fetch(
          `https://backend.whalesai.com/api/v1/img/generate-comic-news-video?dimension=all`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(bodyContent),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to generate video");
        }

        const data = await response.json();
        if (data.message === "Video created successfully") {
          alert("video created successfully");

          setIsLoading(false);
        } else {
          throw new Error("Failed to generate video");
        }
      } catch (error) {
        console.error("Error generating video:", error);
      }
    } else {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",

        icon: "error",
        buttons: "Ok",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/purchase");
        }
      });
    }
  };

  const newsCategories = [
    { value: "Business", text: "Business" },
    { value: "Science", text: "Science" },
    { value: "Singapore", text: "Singapore" },
    { value: "Technology", text: "Technology" },
    { value: "World", text: "World" },
  ];

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const response = await axios.get(
        `https://backend.whalesai.com/api/v1/news/get`,
        {
          params: { category: newsCategory },
        }
      );
      const data = await response.data.articles;
      if (response.data.statusCode === 404) {
        return swal({
          icon: "warning",
          title: "Something Went Wrong!",
          button: "Close",
          className: "modal_class_success",
        });
      }
      setNewsData(data);
      setIsLoading(false);
    })();
  }, [newsCategory]);

  return (
    <Fragment>
      <PageHeading
        title={"NEWS VIDEO AI"}
        description={
          "The News Video AI can generate text-based videos featuring the latest news."
        }
      />

      <SampleTextVideo
        videoModal={videoModal}
        setVideoModal={setVideoModal}
        indexValue={2}
      />

      <SampleVideoModal
        setModalShow={setModalShow}
        modalShow={modalShow}
        videoPosition={videoPosition}
      />

      <div className="img-ai-container container pb-5">
        <div
          sx={{
            maxWidth: "872px",
            paddingInline: "12px",
            marginInline: "auto",
          }}
        >
          <div className="position-relative">
            {" "}
            {/* Adjust height as needed */}
            <IconButton
              style={{
                color: "#ffa21f",
                position: "absolute",
                // top: "calc(0px - 100px)",
                top: "calc(0px - 100px)", "@media (max-width: 575px)": { top: "calc(0px - 70px)" },
                left: "50%", // Horizontal center
                transform: "translateX(-50%)", // Ensures it's centered from its width
              }}
              onClick={() => setVideoModal(true)}
              title="See sample video"
            >
              <InfoIcon />
            </IconButton>
          </div>
          <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm">
            <div className="d-flex ">
              <CreditsButton />
            </div>
          </div>
          <p
            style={{ fontSize: "8px" }}
            className="text-white text-center mt-2 mb-0 centralize-credits-btn-sm"
          >
            35 Credits per video
          </p>
        </div>

        <div className="container pt-3">
          <div style={{ maxWidth: "850px" }} className="mx-auto">
            <div>
              <div className="selectDiv">
                <div className="postais">
                  <div className="d-flex justify-content-center align-items-center">
                    <select
                      onChange={(e) => setNewsCategory(e.target.value)}
                      value={newsCategory}
                      className="selector"
                      id=""
                    >
                      {newsCategories.map((cat) => (
                        <option
                          key={cat.value}
                          className="textai-option"
                          value={cat.value}
                        >
                          {cat.text}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <select
                      onChange={(e) => setEvent(e.target.value)}
                      value={event}
                      className="selector mt-3"
                      id=""
                    >
                      <option className="textai-option" value="All">
                        All
                      </option>
                      <option className="textai-option" value="Day">
                        Today
                      </option>
                      <option className="textai-option" value="Week">
                        This Week
                      </option>
                      <option className="textai-option" value="Month">
                        This Month
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 text-center">
              <button
                onClick={generateNews}
                className="generate-button rounded"
              >
                Retrieve News
              </button>
            </div>

            {/* result data  */}
            {!isLoading && !newsData?.length && (
              <p className="text-center fs-5 text-white mt-4">
                No Result Found!
              </p>
            )}

            {
              <div className="mt-5">
                {randomNews?.map((item, i) => (
                  <div
                    key={i}
                    className="d-flex justify-content-start flex-column flex-md-row align-items-start gap-3 mb-4"
                  >
                    <div className="d-flex mx-auto align-items-start gap-2">
                      <input
                        type="checkbox"
                        checked={oneNews?.title === item?.title}
                        onChange={() => handleCheckedNews(item)}
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                    <div style={{ width: "100%" }}>
                      <div>
                        <p className="mb-2 text-md-start text-center text-primary">
                          {item?.title}
                        </p>
                      </div>

                      <p className="text-white text-md-start text-center mt-3 two-line-text">
                        {item?.summary?.split("\n\n")[0].length > 2
                          ? `${item.summary.split("\n\n")[0]}`
                          : item?.summary?.split("\n\n")[0]}
                      </p>
                      <p
                        className="text-md-start text-center"
                        style={{
                          color: "yellow",
                          marginTop: "0px",
                          fontSize: "14px",
                        }}
                      >
                        {item?.createdAt}(SG Time)
                      </p>
                    </div>
                  </div>
                ))}

              </div>
            }

            {newsCategory && (
              <>

                <div
                  className="d-flex align-items-center justify-content-center text-center mt-4"
                >
                  <input
                    type="checkbox"
                    id="attributionCheckboxInline"
                    style={{ marginRight: '8px' }}
                    checked={attributionPage}
                    onChange={(e) => setAttributionPage(e.target.checked)}
                  />
                  <label htmlFor="attributionCheckboxInline" className="text-white" style={{ fontSize: '14px', cursor: 'pointer' }}>
                    The Attribution
                  </label>
                </div>

                <div
                  className="d-flex align-items-center justify-content-center text-center mt-4 gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <select
                    className="form-select form-select-sm text-uppercase"
                    value={selectedOption}
                    onChange={handleOptionChange}
                    style={{ width: "220px" }}
                  >
                    <option value="">Please select Background</option>

                    <option value="Black to White Gradient">
                      Black to White Gradient
                    </option>

                    <option value="Random Solid Color">
                      Random Solid Color
                    </option>

                    <option value="Random Color Gradient">
                      Random Color Gradient
                    </option>

                    <option value="Black">
                      Black
                    </option>

                    <option value="White">
                      White
                    </option>
                  </select>
                  <span className="text-danger">*</span>
                  {videoPosition === 0 ? (
                    " "
                  ) : (

                    <IconButton
                      style={{ color: "#ffa21f" }}
                      onClick={() => setModalShow(true)}
                      title="See sample video"
                      className="mt-0"
                    >
                      <InfoIcon />
                    </IconButton>
                  )}
                </div>

                {/* Will Implement later: End */}

                <div className="mt-4 text-center gap-4">
                  <button
                    onClick={() => {
                      setNewsData({});
                      setOneNews({});
                    }}
                    className="clear-button rounded mb-4"
                  >
                    Clear
                  </button>
                  <button
                    onClick={handleChecked}
                    className={`generate-button-news rounded ${!oneNews || !selectedOption ? "bg-secondary" : ""
                      }`}
                    disabled={!selectedOption}
                  >
                    GENERATE NEWS VIDEO
                  </button>
                </div>
                <div className=" text-center">
                  <button
                    onClick={handleCheckedComic}
                    className={`generate-button-news mb-2 rounded ${!oneNews || !selectedOption ? "bg-secondary" : ""
                      }`}
                    disabled={!selectedOption}
                  >
                    GENERATE COMIC VIDEO
                  </button>
                </div>
                <div className="animate text-md-center mt-4 text-lg-center text-center mb-5 d-flex justify-content-center force-small-font">
                  Please do not navigate away from the browser.
                  <br /> Doing so will stop the process.
                </div>
                <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
                  While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
                </div>
              </>
            )}
            <div className="btnvideoDiv"></div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default VideoAiNews;
